import { getAcwrColor } from "@utils/acwr_utils";

// metrics → key metrics, sorted by order (same predicate/sort as v1).
export const selectKeyMetrics = (metrics) =>
    (metrics || []).filter((m) => m.is_key_metric).sort((a, b) => a.order - b.order);

// One coloured dot per key metric (grey when that day has no value) — matches ACWRDotContent.
export const buildAcwrDots = (keyMetrics, cellInfo, acwrThresholdConfig) =>
    keyMetrics.map((metric) => ({
        color: getAcwrColor(cellInfo?.[`${metric.key}_ACWR`], acwrThresholdConfig),
    }));

// Tooltip rows — only when the day has data AND at least one *_ACWR key exists (matches getACWRTooltip).
export const buildAcwrRows = (keyMetrics, cellInfo, acwrThresholdConfig) => {
    if (!cellInfo?.player_data_exists_for_curr_day) return null;
    const hasACWRKey = Object.keys(cellInfo).some((key) => key.endsWith("_ACWR"));
    if (!hasACWRKey) return null;

    return keyMetrics.map((metric) => {
        const value = cellInfo[`${metric.key}_ACWR`];
        return {
            name: metric.name,
            value: value !== undefined ? value : "-",
            color: getAcwrColor(value, acwrThresholdConfig),
        };
    });
};
